import { t } from '@lingui/core/macro';

import type { WebSocketAIMessage } from '@/hooks/useAuthWebSocket';

type StatusMessage = Extract<WebSocketAIMessage, { type: 'status' }>;

export type RequestStatus = StatusMessage['payload'];

const KNOWN_STATUS_CODES = [
  'gathering_context',
  'resolving_ids',
  'querying_data',
  'building_url',
  'searching_docs',
] as const;

type KnownStatusCode = (typeof KNOWN_STATUS_CODES)[number];

const hasKnownStatusCode = (code: string): code is KnownStatusCode =>
  KNOWN_STATUS_CODES.includes(code as KnownStatusCode);

export const getLocalizedStatusLabel = (status: RequestStatus | undefined): string => {
  if (!status) {
    return t`Thinking`;
  }

  if (!status.tool || !hasKnownStatusCode(status.code)) {
    return t`Working`;
  }

  switch (status.code) {
    case 'gathering_context':
      return t`Gathering context`;
    case 'resolving_ids':
      return t`Finding objects`;
    case 'querying_data':
      return t`Querying database`;
    case 'building_url':
      return t`Creating link`;
    case 'searching_docs':
      return t`Searching documentation`;
  }
};
